import { useState, useRef, useEffect } from "react";
import { useNotifications } from "../../../contexts/NotificationsContext";
import Icon from "../../a-atoms/icons/Icon";
import NotificationList from "../../c-organism/notifications/NotificationList";
import style from "./NotificationBadge.module.css";
import useOutsideClick from "../../../hooks/useOutsideClick";

const NotificationBadge = () => {
  const { unreadCount } = useNotifications();
  const [showList, setShowList] = useState(false);
  const badgeRef = useRef(null);
  const outsideClick = useOutsideClick(badgeRef);

  useEffect(() => {
    if (outsideClick) {
      setShowList(false);
    }
  }, [outsideClick]);

  const handleClick = () => {
    setShowList(!showList);
  };

  return (
    <div className={style.notificationBadgeContainer} ref={badgeRef}>
      <button
        className={`${style.notificationBadge} ${unreadCount > 0 ? style.hasUnread : style.allRead}`}
        onClick={handleClick}
        title={unreadCount > 0 ? `${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}` : 'No new notifications'}
      >
        <Icon>notifications</Icon>
        {unreadCount > 0 && (
          <span className={style.badgeCount}>{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>
      {showList && <NotificationList onClose={() => setShowList(false)} />}
    </div>
  );
};

export default NotificationBadge;

